// ModalContext.js
import React, { createContext, useState } from "react";

// Create Context
export const LocationModalContext = createContext();

// Context Provider Component
export const LocationModalProvider = ({ children }) => {
    const [expandedItems, setExpandedItems] = useState([]);
    const [locationModal, setLocationModal] = useState(false);
    const [selectedAccountId, setSelectedAccountId] = useState(null);
    const [locationModalType, setLocationModalType] = useState(null);
    const [modalTreeCheckedItem, setModalTreeCheckedItem] = useState([]);
    const [modalTreeExpandedItems, setModalTreeExpandedItems] = useState([]);

    // Function to toggle modal
    const toggleLocationModal = () => {
        setLocationModal((prev) => !prev);
    };

    const expandParentNodeAfterAddingData = (index) => {
        var id = index;
        if (typeof index === 'number' && !isNaN(index)) {
            id = index.toString();
        }
        if (!id) return;

        setExpandedItems((prev) =>
            prev.includes(id) ? prev : [...prev, id]
        );

        
    } 

    return (
        <LocationModalContext.Provider value={
            {
                locationModal,
                toggleLocationModal,
                selectedAccountId,
                setSelectedAccountId,
                locationModalType,
                setLocationModalType,
                modalTreeCheckedItem,
                setModalTreeCheckedItem,
                modalTreeExpandedItems,
                setModalTreeExpandedItems,
                expandedItems,
                setExpandedItems,
                expandParentNodeAfterAddingData
            }}>
            {children}
        </LocationModalContext.Provider>
    );
};
